import React from "react";
import Container from "../General/Container/Container";
import { getWhiteLabelDictionary } from "../../utils/whitelabel/WhiteLabel.Helper";
import { activelyInterestedObj, highlyEngagedObj } from "../../config/TableColumns.config";

const MinifiedResultSummary = ({ summary }) => {
    return <Container className="minified-result-item dcol align-center">
        <span className="minified-result-item-title">Summary</span>
        <Container className="minified-result-item-subtitle drow align-center">
            <span>{getWhiteLabelDictionary(highlyEngagedObj.key, highlyEngagedObj.title)}</span>
            <span>and</span>
            <span>{getWhiteLabelDictionary(activelyInterestedObj.key, activelyInterestedObj.title)}</span>
        </Container>
        <span className="border-item" />
        <p className="minified-result-item-summary">
            {summary}
        </p>
    </Container>
}

export default MinifiedResultSummary